<template>
  <div style="width: 100%;height: 100%">
    <div class="title"><span>人员结构</span></div>
    <div class="content">
      <el-row style="height: 100%">
        <el-col :span="8" style="height: 100%">
          <div style="width: 100%;height: 100%">
            <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="ageBar" ref="ageWrap"></div>
          </div>
        </el-col>
        <el-col :span="16" style="height: 100%">
          <div style="width: calc(100% - 20px);height: 100%;margin-left: 20px">
            <el-row style="height: 100%">
              <el-col :span="8" style="height: 100%">
                <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="economicBar" ref="economicWrap"></div>
              </el-col>
              <el-col :span="8" style="height: 100%">
                <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="householdBar" ref="householdWrap"></div>
              </el-col>
              <el-col :span="8" style="height: 100%">
                <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="medicalBar" ref="medicalWrap"></div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {queryelderlycountbyage} from '../../../api/yanglaoyuan/dataScreen'
import HighCharts from 'highcharts'
export default {
  name: 'checkinStatistic',
  data () {
    return {
      ageChart: null,
      ageData: [],
      ageMax: 0,

      householdChart: null,
      householdData: [],

      radarMax: 0,
      indicatorData: [],
      economicChart: null,
      economicData: [],

      funnelMax: 0,
      medicalChart: null,
      medicalData: []
    }
  },
  mounted () {
    window.addEventListener('resize', this.chartResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
    if (this.ageChart) {
      this.ageChart.dispose()
      this.ageChart = null
    }
    if (this.householdChart) {
      this.householdChart.dispose()
      this.householdChart = null
    }
    if (this.economicChart) {
      this.economicChart.dispose()
      this.economicChart = null
    }
    if (this.medicalChart) {
      this.medicalChart.dispose()
      this.medicalChart = null
    }
  },
  methods: {
    getStartData (obj) {
      this.radarMax = obj.bindbedcount
      this.getAgeChartData()
      this.getHouseholdChartData(obj.nationcount)
      this.getEconomicChartData(obj.economycount)
      this.getMedicalChartData(obj.medicalcount)
    },

    getAgeChart () {
      HighCharts.chart('ageBar', {
        title: {
          text: '年龄阶段',
          style: {color: '#bac3c4', fontSize: 14, fontWeight: 'bold'}
        },
        chart: {
          backgroundColor: '#00000000',
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 60
          }
        },
        plotOptions: {
          pie: {
            innerSize: 60,
            depth: 40,
            dataLabels: {
              enabled: true,
              color: '#bac3c4'
            }
          }
        },
        /* 去logo */
        credits: {
          enabled: false
        },
        series: [
          {
            name: '人数',
            data: this.ageData
            // colors: ['rgba(0, 174, 255, 0.9)', 'rgba(255, 29, 29,0.9)', 'rgba(22,38,255,0.9)', 'rgba(249,175,26,0.9)',
            //   'rgba(255, 109, 130, 0.9)', 'rgba(171, 109, 255, 0.9)', 'rgba(110, 255, 148, 0.9)', 'rgba(229, 229, 23, 0.9)']
          }
        ]
      })
    },
    getAgeChartData () {
      let that = this
      this.ageData = []
      this.ageMax = 0
      queryelderlycountbyage().then(res => {
        let arr = res.data.elderlycountbyage
        arr.forEach(item => {
          if (item.age_group !== '总数') {
            let arr = []
            arr.push(item.age_group)
            arr.push(parseInt(item.personcount))
            that.ageData.push(arr)
            // let obj = {
            //   value: item.personcount,
            //   name: item.age_group
            // }
            // that.ageData.push(obj)
          } else {
            this.ageMax = item.personcount
          }
        })
        this.getAgeChart()
      })
    },

    getHouseholdChart () {
      if (!this.householdChart) {
        this.householdChart = this.$echarts.init(this.$refs.householdWrap)
      }
      let option = {
        title: {
          text: '户籍情况',
          textStyle: {
            color: '#bac3c4',
            fontSize: 14
          },
          left: 'center',
          top: '2%'
        },
        legend: {
          // width: 200,
          height: 50,
          bottom: '0',
          orient: 'vertical',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        grid: {top: '5%', left: '5%', right: '5%', bottom: '5%', containLabel: true},
        series: [
          {
            type: 'pie',
            top: -40,
            radius: ['20%', '35%'],
            // center: ['50%', '50%'],
            data: this.householdData,
            // roseType: 'radius',
            label: {
              show: true,
              formatter: '{name|{b}}\n\n{percent|{d}%}',
              rich: {
                name: {color: '#bac3c4'},
                percent: {color: 'auto'}
              }
            }
          }
        ]
      }
      this.householdChart.setOption(option)
    },
    getHouseholdChartData (nationCountArr) {
      let that = this
      this.householdData = []
      this.commonType.getHouseholdArr().forEach(item => {
        let value = 0
        let nationCount = nationCountArr.find(r => r.datatype === item.id)
        if (nationCount) {
          value = parseInt(nationCount.count)
        }
        that.householdData.push({name: item.name, value: value})
      })
      // if (nationCountArr.find(r => r.datatype === '')) {
      //   this.householdData.push(({name: '未知', value: nationCountArr.find(r => r.datatype === '').count}))
      // }
      this.getHouseholdChart()
    },

    getEconomicChart () {
      if (!this.economicChart) {
        this.economicChart = this.$echarts.init(this.$refs.economicWrap)
      }
      let option = {
        title: {
          text: '经济来源',
          textStyle: {
            color: '#bac3c4',
            fontSize: 14
          },
          left: 'center',
          top: '2%'
        },
        legend: {
          // width: 200,
          bottom: 'bottom',
          left: 'center',
          // orient: 'vertical',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        grid: {top: '5%', left: '5%', right: '5%', bottom: '5%', containLabel: true},
        radar: {
          // shape: 'circle',
          center: ['50%', '60%'],
          radius: '70%',
          startAngle: 90,
          axisName: {
            color: '#fff'
          },
          nameGap: 10,
          axisLine: {
            lineStyle: {
              color: '#333'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#333'
            }
          },
          indicator: this.indicatorData
        },
        series: [
          // {
          //   type: 'pie',
          //   top: -40,
          //   radius: ['20%', '35%'],
          //   // center: ['50%', '50%'],
          //   data: this.economicData,
          //   // roseType: 'radius',
          //   label: {
          //     show: true,
          //     formatter: '{name|{b}}\n\n{percent|{d}%}',
          //     rich: {
          //       name: {color: '#bac3c4'},
          //       percent: {color: 'auto'}
          //     }
          //   }
          // }
          {
            name: '经济来源',
            type: 'radar',
            data: [
              {
                value: this.economicData
              }
            ]
          }
        ]
      }
      this.economicChart.setOption(option)
    },
    getEconomicChartData (economyCountArr) {
      let that = this
      this.economicData = []
      this.commonType.getEconomicArr().forEach(item => {
        let value = 0
        let economyCount = economyCountArr.find(r => parseInt(r.datatype) === item.id)
        if (economyCount) {
          value = parseInt(economyCount.count)
        } else {
          // if (item.id === 1) value = 12
          // else if (item.id === 2) value = 6
          // else if (item.id === 3) value = 2
        }
        that.indicatorData.push({name: item.name, max: this.radarMax})
        that.economicData.push(value)
      })
      // if (economyCountArr.find(r => r.datatype === '')) {
      //   this.indicatorData.push({name: '未知', max: this.radarMax})
      //   this.economicData.push(economyCountArr.find(r => r.datatype === '').count)
      // }
      this.getEconomicChart()
    },

    getMedicalChart () {
      if (!this.medicalChart) {
        this.medicalChart = this.$echarts.init(this.$refs.medicalWrap)
      }
      let option = {
        title: {
          text: '医保类型',
          textStyle: {
            color: '#bac3c4',
            fontSize: 14
          },
          left: 'center',
          top: '2%'
        },
        // legend: {
        //   // width: 200,
        //   bottom: 'bottom',
        //   left: 'center',
        //   // orient: 'vertical',
        //   textStyle: {
        //     color: '#fff'
        //   }
        // },
        tooltip: {
          trigger: 'item'
        },
        grid: {top: '5%', left: '5%', right: '5%', bottom: '5%', containLabel: true},
        series: [
          // {
          //   type: 'pie',
          //   top: -40,
          //   radius: ['20%', '35%'],
          //   // center: ['50%', '50%'],
          //   data: this.medicalData,
          //   // roseType: 'radius',
          //   label: {
          //     show: true,
          //     formatter: '{name|{b}}\n\n{percent|{d}%}',
          //     rich: {
          //       name: {color: '#bac3c4'},
          //       percent: {color: 'auto'}
          //     }
          //   }
          // }
          {
            type: 'funnel',
            width: '50%',
            height: '80%',
            top: '15%',
            left: '15%',
            // radius: ['20%', '35%'],
            // center: ['50%', '50%'],
            min: 0,
            max: this.funnelMax,
            minSize: '0%',
            maxSize: '100%',
            sort: 'ascending',
            funnelAlign: 'center',
            gap: 5,
            data: this.medicalData,
            // roseType: 'radius',
            label: {
              show: true,
              formatter: '{name|{b}}\n\n{percent|{d}%}',
              textBorderWidth: 0,
              rich: {
                name: {color: '#bac3c4'},
                percent: {color: 'auto'}
              }
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid'
              }
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 0
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            }
          }
        ]
      }
      this.medicalChart.setOption(option)
    },
    getMedicalChartData (medicalCountArr) {
      let that = this
      this.medicalData = []
      this.commonType.getMedicalGuaranteeArr().forEach(item => {
        let value = 0
        let medicalCount = medicalCountArr.find(r => parseInt(r.datatype) === item.id)
        if (medicalCount) {
          value = parseInt(medicalCount.count)
        } else {
          // if (item.id === 1) value = 20
          // else if (item.id === 2) value = 40
          // else if (item.id === 3) value = 60
        }
        if (value > that.funnelMax) {
          that.funnelMax = value
        }
        that.medicalData.push({name: item.name, value: value})
      })
      // if (medicalCountArr.find(r => r.datatype === '')) {
      //   let value = parseInt(medicalCountArr.find(r => r.datatype === '').count)
      //   this.medicalData.push(({name: '未知', value: value}))
      //   if (value > this.funnelMax) {
      //     this.funnelMax = value
      //   }
      // }
      this.getMedicalChart()
    },

    chartResize () {
      this.ageChart.resize()
      this.householdChart.resize()
      this.economicChart.resize()
      this.medicalChart.resize()
    }
  }
}
</script>

<style scoped>
  .title {
    padding-left: 55px;
    height: 32px;
    width: calc(100% - 55px);
    background: url("../../../assets/dataScreen/title2.png") no-repeat;
    background-size: 100% 100%;
    color: #ffffff;
    font-size: 15px;
    line-height: 32px;
  }
  .content {
    height: calc(100% - 52px);
    width: calc(100% - 20px);
    padding: 10px;
    background-image: linear-gradient(
      #0b182c,
      #0b182c),
    linear-gradient(
      #03171f,
      #03171f);
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/dataScreenComponents/checkinStatistic.vue